<template>
  <v-btn
    :color="color"
    :disabled="disabled"
    :loading="loading"
    class="rounded-pill text-none px-5"
    :class="darkText ? '' : 'text-white'"
    @click.stop="emitClick"
    variant="elevated"
    :elevation="elevation"
  >
    <slot></slot>
  </v-btn>
</template>
<script setup lang="ts">

interface Props {
  loading?: boolean
  disabled?: boolean
  color?: string
  darkText?: boolean
  elevation?: number
}

const {
  loading = false,
  disabled = false,
  color = 'pwt_palatinate_blue',
  darkText = false,
  elevation = undefined,
} = defineProps<Props>()

const emit = defineEmits(['click'])

function emitClick() {
  emit('click')
}
</script>
